import { render, staticRenderFns } from "./SrModalPage.vue?vue&type=template&id=077ec614"
import script from "./SrModalPage.vue?vue&type=script&lang=js"
export * from "./SrModalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports